import {
  // GET_QUIZES,
  FETCH_START,
  FETCH_SUCCESS,
  FETCH_ERROR,
  SET_PAGE,
  SET_SEARCH,
  SHOW_MESSAGE,
  SET_SORT_BY,
  SET_ORDER_BY,
  DELEETE_QUIZE,
  GET_QUIZES,
} from "../../shared/constants/ActionTypes";

import jwtAxios from "@crema/services/auth/jwt-auth/jwt-api";

export const getQuizList = () => {
  return (dispatch, getState) => {
    const state = getState().quiz;
    dispatch({ type: FETCH_START });
    jwtAxios
      .post("/quiz/list", {
        page: state.page,
        limit: state.orderby,
      })
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_QUIZES, payload: data.data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const createQuiz = (payload, closeModel) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    
    // Log quiz creation attempt with question details
    console.log('Quiz Creation Started:', {
      timestamp: new Date().toISOString(),
      quizType: payload.quizType,
      courseId: payload.courseId,
      moduleId: payload.moduleId,
      questions: payload.data.map(q => ({
        type: q.questionType,
        question: q.question,
        points: q.questionPoints,
        numberOfAnswers: q.answers.length,
        hasCorrectAnswer: q.answers.some(a => a.isCorrect)
      }))
    });

    jwtAxios
      .post("/quiz/add", payload)
      .then((data) => {
        if (data.status === 200) {
          // Log successful quiz creation
          console.log('Quiz Created Successfully:', {
            timestamp: new Date().toISOString(),
            quizId: data.data._id,
            numberOfQuestions: payload.data.length,
            questionTypes: [...new Set(payload.data.map(q => q.questionType))],
            settings: {
              randomQuestions: payload.randomQuestions,
              randomAnswers: payload.randomAnswers,
              passingPercentage: payload.passingPercentage,
              completionTime: payload.completionTime,
              questionPerPage: payload.questionPerPage
            }
          });
          
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: SHOW_MESSAGE, payload: "Quiz added successfully." });
          dispatch(getQuizList());
          closeModel();
        } else {
          // Log quiz creation failure
          console.error('Quiz Creation Failed:', {
            timestamp: new Date().toISOString(),
            error: "Failed to create quiz",
            payload: payload
          });
          
          dispatch({ type: FETCH_ERROR, payload: "Failed to create quiz!" });
        }
      })
      .catch((error) => {
        // Log quiz creation error
        console.error('Quiz Creation Error:', {
          timestamp: new Date().toISOString(),
          error: error.response?.data?.msg || error.message,
          payload: payload
        });
        
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const deleteQuiz = (payload) => {
  return (dispatch, getState) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .put("/quiz/delete", {
        id: payload.id,
      })
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: DELEETE_QUIZE, payload: data.data.data });
          dispatch(getQuizList());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const updateQuiz = (payload, closeModel) => {
  return (dispatch, getState) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .put("/quiz/edit", payload)
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: SHOW_MESSAGE,
            payload: "Quiz updated successfully.",
          });
          dispatch(getQuizList());
          closeModel();
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const setPage = (page) => {
  return (dispatch) => {
    dispatch({ type: SET_PAGE, payload: page });
  };
};
export const setSearch = (search) => {
  return (dispatch) => {
    dispatch({ type: SET_SEARCH, payload: search });
  };
};
export const setOrderBy = (orderby) => {
  return (dispatch) => {
    dispatch({ type: SET_ORDER_BY, payload: orderby });
  };
};
export const setSortBy = (sortby) => {
  return (dispatch) => {
    dispatch({ type: SET_SORT_BY, payload: sortby });
  };
};
